const initialState = {
};
function rootReducer(state = initialState, action) {
    if (action.type === "SET_STATE") {
        state = { ...state, ...action.state }
    }
    return state;
};
export default rootReducer;